import { BlocksIconWarningCircleFilled } from 'blocks-nextjs/blocks-web-components/components/icon/icons/warning-circle-filled';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconWarningCircleFilled = createComponent({
  react: React,
  tagName: 'cat-icon-warning-circle-filled',
  elementClass: BlocksIconWarningCircleFilled
});
